import { ToastContainer, toast } from "react-toastify";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "../../style/student.css";
import { AiTwotoneDashboard } from "react-icons/ai";
import { TbAbc } from "react-icons/tb";
import { GiBracers } from "react-icons/gi";

import { logout } from "../../firebase-functions/auth";
import logo from "../../assets/img/logo.png";

import { FcSportsMode } from "react-icons/fc";

export const StudentNavbar = (props) => {
  const [toggleNavbar, setNavbar] = useState(true);
  const [links, setLinks] = useState([]);

  const handleLogout = () => {
    logout().then((res) => {
      if (res.success) {
        toast.success("logged out successfully");
        setTimeout(() => {
          window.location.replace("/login");
        }, 500);
      } else {
        toast.error("Something went horribly wrong");
      }
    });
  };

  const [isNavOpen, setNavOpen] = useState(false);

  const toggleNav = () => {
    setNavOpen(!isNavOpen);
  };

  const [isMobile, setIsMobile] = useState(false);
  const role = props?.role;

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    // Initial check
    handleResize();

    // Add event listener for resizing
    window.addEventListener("resize", handleResize);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [toggleNavbar]);

  return (
    <div>
      <ToastContainer />
      <nav
        className={`navbar ${isMobile ? "mobile" : ""}  ${
          toggleNavbar ? "" : "navbar-container-closed"
        }`}
      >
        <div className="logo">
          <Link to="/">
            <img src={logo} alt="logo book-battle" className="img-logo" />
          </Link>
        </div>
        {isMobile ? (
          <></>
        ) : (
          <div className={`navbar-container`}>
            <ul className="nav-links">
              {role === "student" &&
                [
                  // { name: "Dashboard", link: "dashboard" },
                  // { name: "Levels", link: "reading-room/levels" },
                  // // { name: "Phrases", link: "phrases" },
                  // { name: "Account", link: "account" },
                ].map((li) => (
                  <li key={li.name}>
                    <Link to={li.link}>{li.name}</Link>
                  </li>
                ))}

              {role === "guest" && (
                <>
                  <Link to="login" className="btn-logout">
                    Login
                  </Link>
                </>
              )}
            </ul>
          </div>
        )}
      </nav>
      <div className="burger">
        <ul className="nav-links-mobile-open">
          {role === "guest" && (
            <Link
              to="login"
              className="btn-logout"
              onClick={() => {
                setNavOpen(false);
              }}
            ></Link>
          )}
          {["student"].includes(role) && (
            <>
              <Link to={"/dashboard"}>
                <AiTwotoneDashboard />
              </Link>

              <Link to={"/reading-room/levels"}>
                <TbAbc />
              </Link>

              {/* <Link to={"/reading-room/assignments"}>
                <GiBracers />
              </Link> */}

              <FcSportsMode
                className="btn-logout"
                style={{ margin: "auto", fontSize: "2em" }}
                onClick={() => {
                  handleLogout();
                }}
              />
            </>
          )}
        </ul>
      </div>
    </div>
  );
};
